<template>
  <div class="PowerDistribution">
    <div class="top" id="svgContent">
      <div class="title">
        <!-- <el-cascader v-model="cascaderValue" :options="cascaderOptions" :props="{ expandTrigger: 'hover' }"
        @change="handleChange"></el-cascader> -->
        <el-select v-model="svgUrl" placeholder="请选择">
          <el-option
            v-for="(item, index) in options"
            :key="`${item.id}-${index}`"
            :label="item.name"
            :value="item.DistributionDiagram"
          >
          </el-option>
        </el-select>
      </div>
      <div class="content">
        <SvgD3
          :key="svgKey"
          svgId="svgPowerDistribution"
          :svgUrl="svgUrl"
          :svgUrlType="svgUrlType"
        />
      </div>
    </div>
    <div class="bottom">
      <div>
        <TableWithJump
          titleName="配电系统报警"
          :listData="alarmListData"
          :tableData="alarmTableData"
          :tableDataHead="alarmTableHead"
          :jumpUrl="{
            name: 'distributingDevOps',
            params: { id: '告警' },
          }"
        />
      </div>
      <div>
        <TableWithJump
          titleName="配电系统工单"
          :listData="workListData"
          :tableData="workTableData"
          :tableDataHead="workTableHead"
          :jumpUrl="{
            name: 'distributingDevOps',
            params: { id: '工单' },
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SvgD3 from "@/components/Svg/SvgD3";
import TableWithJump from "@/components/TableWithJump/TableWithJump";
import api from "@/api";
import {
  dateFtt,
  matchingAlarmLevel,
  matchingOrderLevel,
  formatTime,
  getUserInfoVal,
  getProjectVal,
} from "@/assets/js/utils";
export default {
  name: "PowerDistribution",
  props: {},
  components: { TableWithJump, SvgD3 },
  data() {
    return {
      svgKey: 1,
      options: [],
      svgUrl: "@/assets/images/svg/empty.svg",
      //报警
      alarmListData: [],
      alarmTableData: [],
      alarmTableHead: [
        { label: "ID", prop: "alarmId" },
        { label: "报警时间", prop: "time" },
        { label: "设备名称", prop: "deviceName" },
        { label: "设备/区域地址", prop: "location" },
        { label: "处理状态", prop: "confirm" },
        { label: "报警级别", prop: "level" },
      ],
      //工单
      workListData: [],
      workTableData: [],
      workTableHead: [
        { label: "工单ID", prop: "id" },
        { label: "工单名称", prop: "description" },
        { label: "工单级别", prop: "priority" },
        { label: "地点", prop: "location" },
        { label: "处理人", prop: "handlers" },
        { label: "处理时长", prop: "time" },
      ],
    };
  },
  computed: {
    svgUrlType: function () {
      return this.svgUrl.includes("@/assets") ? "path" : "url";
    },
  },
  methods: {
    async getAlarmsList() {
      let res = await api.lightingOSGetAlarms({
        projectId: getProjectVal("Id"),
        deviceType: "配电系统",
        pageSize: 5,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.alarmListData = Array.from(res.data.data.statistics).map(
          (item) => ({
            name: item.name == "total" ? "全部" : matchingAlarmLevel(item.name),
            value: item.value,
          })
        );
        this.alarmTableData = res.data.data.page.data;
        this.alarmTableData.map((v) => {
          v.time = v.endTime
            ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endTime))
            : "";
          v.confirm = v.confirm ? "已确认" : "未确认";
          v.level = matchingAlarmLevel(v.level);
        });
      }
    },
    async getWorkOrderList() {
      let res = await api.lightingOSGetWorkOrder({
        projectId: getProjectVal("Id"),
        deviceType: "配电系统",
        pageSize: 5,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.workListData = Array.from(res.data.data.statistics).map(
          (item) => ({
            name: item.name == "total" ? "全部" : matchingOrderLevel(item.name),
            value: item.value,
          })
        );
        this.workTableData = res.data.data.page.data;
        this.workTableData.map((v) => {
          v.priority = matchingOrderLevel(v.priority);
          v.time = v.ts ? formatTime(v.ts) : "";
          v.handlers = v.assignStaffNames.join("、");
        });
      }
      // console.log(res);
    },
    handleChange(val) {
      console.log("handleChange---", val);
    },
    //selectOptions
    async getHasSvgAssets() {
      let res = await api.DSGetHasSvgAssets({
        projectId: getProjectVal("Id"),
        attributeKey: "DistributionDiagram",
        assetType: "配电系统",
      });
      if (res && res.data?.code == 200) {
        const selectOptions = [];
        Array.isArray(res.data.data) &&
          res.data.data.forEach((element, index) => {
            const value = {
              ...element,
              DistributionDiagram: `${
                element.DistributionDiagram
              }?tenant_id=${getUserInfoVal("tenantId")}`,
            };
            if (index === 0) {
              this.svgUrl = value.DistributionDiagram;
            }
            selectOptions.push(value);
          });
        this.options = selectOptions;
      } else {
        console.log("获取svgSelectOptions失败");
      }
    },
  },
  watch: {
    svgUrl(val) {
      this.svgKey = new Date().getTime();
    },
  },
  created() {
    this.getHasSvgAssets();
    this.getAlarmsList();
    this.getWorkOrderList();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.PowerDistribution {
  margin: 16px;
  width: calc(100% - 32px);
  .top {
    width: 100%;
    height: 700px;
    .title {
      text-align: center;
      height: 40px;
    }

    .content {
      margin-top: 8px;
      height: calc(100% - 55px);
      // height: 100%;
      width: 100%;
    }
  }
  .bottom {
    // width: calc(100% - 32px);
    margin: 12px 0px;
    // width: 96%;
    // margin: 0 auto;
    height: 500px;
    @include setFlexBetween;

    & > div {
      width: 49.5%;
      height: 100%;
    }
  }
}
</style>
